import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=793139da&"
import script from "./SettingsSection.vue?vue&type=script&lang=js&"
export * from "./SettingsSection.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793139da')) {
      api.createRecord('793139da', component.options)
    } else {
      api.reload('793139da', component.options)
    }
    module.hot.accept("./SettingsSection.vue?vue&type=template&id=793139da&", function () {
      api.rerender('793139da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/SettingsSection.vue"
export default component.exports